<template>
	<div v-katex:auto>
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="practice bg_gray practice_second">
			<div class="flex famous_position w1200">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/study" class="cl_gray">趣学习</router-link>  >  错题本</p>
				</div>
				<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
			</div>
			<div class=" bg_white radius8 bs w1200">
				<div class="topic">
					<div class="topic_header">
						<div class="practice_title f20px cl_dark">我的错题</div>
						<div class="topic_nav cl_gray tc">
							<div class="topic_nav_list bg_gray cur" v-for="(item,index) in subject" :key="index"
							 :class="{'on':item.subjectId == subjectCur.subjectId}" @click="navCheck(index)">{{item.subjectName}}</div>
						</div>
					</div>
					<div class="topic_cont">
						<div class="topic_num f18px mat25 mab10" v-if="list.length > 0">共&nbsp;<span class="cl_yel">{{total}}</span>&nbsp;题</div>
						<div class="topic_list_cont" v-if="list.length > 0">
							<div class="topic_list" v-for="(item,index) in list" :key="index">
								<div class="topic_list_title f18px cl_dark">
									<div class="topic_list_title_l">{{index+1}}、</div>
									<div class="topic_list_title_r" v-html="item.title"></div>
								</div>
								<div class="topic_list_check f18px cl_dark flex mat20">
									<div class="topic_list_check_item" v-if="item.option_a != ''">
										<div class="topic_list_check_item_l">A.</div>
										<div class="topic_list_check_item_r" v-html="item.option_a"></div>
									</div>
									<div class="topic_list_check_item" v-if="item.option_b != ''">
										<div class="topic_list_check_item_l">B.</div>
										<div class="topic_list_check_item_r" v-html="item.option_b"></div>
									</div>
									<div class="topic_list_check_item" v-if="item.option_c != ''">
										<div class="topic_list_check_item_l">C.</div>
										<div class="topic_list_check_item_r" v-html="item.option_c"></div>
									</div>
									<div class="topic_list_check_item" v-if="item.option_d != ''">
										<div class="topic_list_check_item_l">D.</div>
										<div class="topic_list_check_item_r" v-html="item.option_d"></div>
									</div>
									<div class="topic_list_check_item" v-if="item.option_e != ''">
										<div class="topic_list_check_item_l">E.</div>
										<div class="topic_list_check_item_r" v-html="item.option_e"></div>
									</div>
								</div>
								<div class="topic_list_btm flex mat20">
									<div class="topic_list_btm_l flex">
										<img src="../../../static/icon_time.png" />
										<span class="cl_gray mal5">{{item.add_time}}</span>
									</div>
									<div class="topic_list_btm_r flex tc">
										<div class="topic_list_delete cl_red cur" @click="topicDelete(index)">
											<img src="../../../static/delete_red.png" />
											<span class="mal5">删除</span>
										</div>
										<div class="topic_list_btn cl_white cur" @click="proofBtn(index)">解析</div>
									</div>
								</div>
							</div>
						</div>
						<div class="famous_page tc" v-if="list.length > 0">
							<div class="famous_page_r cl_dark">
								<el-pagination background layout="prev, pager, next, jumper" @size-change="handleSizeChange" 
								@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
							</div>
						</div>
						<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
							<p>该学科暂时没有错题记录</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
		<!-- 解析 -->
		<div class="bg" v-if="proofShow == true" @click="proofClose"></div>
		<div class="proof proof_second bg_white radius8 bs" :class="{'on':proofShow}">
			<div class="proof_close">
				<img src="../../../static/close_violet.png" class="cur" @click="proofClose" />
			</div>
			<div class="proof_title f22px tc">习题解析</div>
			<div class="proof_div mat20">
				<div class="proof_subject">
					<div class="proof_subject_title f16px" v-html="proofPaper.title"></div>
					<div class="proof_subject_cont cl_gray mat20" v-if="proofPaper.subquestions">
						<div class="proof_subject_list mat5" v-for="(item,index) in proofPaper.subquestions" :key="index" v-html="item.title"></div>
					</div>
					<div class="proof_subject_check mat20" v-if="proofPaper.option_a != ''">
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_a != ''">
							<div class="proof_subject_check_list_l">A.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_a"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_b != ''">
							<div class="proof_subject_check_list_l">B.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_b"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_c != ''">
							<div class="proof_subject_check_list_l">C.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_c"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_d != ''">
							<div class="proof_subject_check_list_l">D.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_d"></div>
						</div>
						<div class="proof_subject_check_list mat5" v-if="proofPaper.option_e != ''">
							<div class="proof_subject_check_list_l">E.</div>
							<div class="proof_subject_check_list_r" v-html="proofPaper.option_e"></div>
						</div>
					</div>
				</div>
				<div class="proof_analysis mat30">
					<div class="proof_analysis_l f18px">答案：</div>
					<div class="proof_analysis_r" v-html="proofPaper.answer2"></div>
				</div>
				<div class="proof_analysis mat30">
					<div class="proof_analysis_l f18px">解析：</div>
					<div class="proof_analysis_r" v-html="proofPaper.parse"></div>
				</div>
			</div>
			<div class="mat20 proof_btm_close tc">
				<span class="inline f18px cl_violet cur" @click="proofClose">关闭</span>
			</div>
		</div>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'wrong',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: -1, //导航
				myInfo: {},
				public: {},
				subject: [], //学科
				subjectCur: {},
				list: [], //题目
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				proofShow: false, //解析显示
				proofPaper: {}, //解析选中题目
			}
		},
		created() {
			
		},
		destroyed () {
			
		},
		mounted() {
			this.getSubject();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subjectCur = this.subject[0];
					this.getList();
				});
			},
			//学科选择
			navCheck (e) {
				this.subjectCur = this.subject[e];
				this.currentPage = 1;
				this.getList();
			},
			//题目列表
			getList () {
				var that = this;
				var params = {};
				params.token = localStorage.getItem("token");
				params.subject_id = that.subjectCur.subjectId;
				params.page = that.currentPage;
				params.limit = that.pageSize;
				that.list = [];
				that.$get("/api/user/get_error_topic",params)
				.then(res => {
					that.list = res.data.data;
					that.total = res.data.total;
				});
			},
			//删除
			topicDelete (e) {
				var that = this;
				that.$messageBox.confirm('确认删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$get("/api/user/post_error_topic_del",{
						token: localStorage.getItem("token"),
						id: that.list[e].uqe_id,
					})
					.then(res => {
						that.$message({
							type: 'success',
							message: '删除成功',
							duration: 2000,
						});
						setTimeout(() => {
							that.currentPage = 1;
							that.getList();
						}, 2000);
					});
					
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//解析
			proofBtn (e) {
				var that = this;
				
				that.proofPaper = that.list[e];
				setTimeout(() => {
					that.proofShow = true;
				}, 0);
			},
			proofClose () {
				this.proofShow = false;
			},
			
			handleSizeChange: function (size) {
				this.pageSize = size;
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
